import React, { useState, useEffect } from "react";
// https://react-bootstrap.github.io/components/cards/#card-columns
import { CardColumns, Card, Button } from "react-bootstrap";
import { filteredProjects, projectData } from "../../data";
import {
  ProjectsError,
  ProjectsLoading,
} from "../components/projectsLoadingError";

// Image
import defualtImage from "../images/logo.svg";
import rideBuddy from "../images/projects/rideBuddy.jpg";
import groceryHub from "../images/projects/groceryHub.jpg";
import eventPlanner from "../images/projects/eventPlanner.jpg";
import sportsMaster from "../images/projects/sportsMaster.jpg";
import footballManager from "../images/projects/footballManager.jpg";
import cp from "../images/projects/contestProgramming.jpg";


const Projects = ({ theme, githubUsername }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  ///project data
  const projectData = [
    {
      id: 1,
      title: 'Event Planner',
      description: 'A full stack Event management app with firebase authentication using Node, React, MongoDB',
      image: eventPlanner,
      liveSite: 'https://event-planner-83916.web.app/',
      clientCode: 'https://github.com/asrezoun/event-planner',
      serverCode: 'https://github.com/asrezoun/event-planner-server',
      text: 'View Website' 
    },
    {
      id: 4,
      title: 'Sports Master',
      description: 'A frontend focused football team viewer app with React, React Router React hooks, Rest api',
      image: sportsMaster,
      liveSite: 'https://objective-minsky-271310.netlify.app/',
      clientCode: 'https://github.com/asrezoun/sports-master/',
      serverCode: '',
      text: 'View Website' 
    },
    {
      id: 2,
      title: 'Grocery Hub',
      description: 'A full stack shopping app with firebase authentication using Node, React, MongoDB',
      image: groceryHub,
      liveSite: 'https://grocery-hub-2cc75.web.app/',
      clientCode: 'https://github.com/asrezoun/grocery-hub',
      serverCode: 'https://github.com/asrezoun/grocery-hub-server',
      text: 'View Website' 
    },
     
    {
      id: 5,
      title: 'Football Manager',
      description: 'A frontend focused player selection app with React, React hooks, FakeData and fontawesome icons',
      image: footballManager,
      liveSite: 'https://footballmanager.netlify.app/',
      clientCode: 'https://github.com/asrezoun/football-manager/',
      serverCode: '',
      text: 'View Website' 
    },
    {
      id: 3,
      title: 'Ride Buddy',
      description: 'A frontend focused ride selection app with firebase authentication, React, Google maps',
      image: rideBuddy,
      liveSite: 'https://ride-buddy-6973e.web.app/',
      clientCode: 'https://github.com/asrezoun/ride-buddy',
      serverCode: '',
      text: 'View Website' 
    },

    {
      id: 6,
      title: 'Solved Problems',
      description: 'Collection of problems that I have solved from different online judges. Such as codeforces, codechef, hackerrank, hackerearth, spoj, atcoder etc',
      image: cp,
      liveSite: 'https://github.com/asrezoun/contest-programming/',
      clientCode: '',
      serverCode: '',
      text: 'View Solved problems' 
    }
  ]

  const githubUrl = `https://api.github.com/users/${githubUsername}/repos`;

  useEffect(() => {
    fetch(githubUrl)
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          return response.json();
        } else {
          setIsError(true);
          setIsLoading(false);
          setError(response.statusText);
          throw new Error(response.statusText);
        }
      })
      .then((data) => {
        let check = false;
        if (filteredProjects.length !== 0) {
          let tempObj = {};
          data.forEach((element, index) => {
            tempObj[element.name] = index;
          });
          check = filteredProjects.every((element) => {
            return tempObj[element] !== undefined;
          });
        }
        if (check) {
          let newData = data.filter((projects) =>
            filteredProjects.includes(projects.name)
          );
          if (projectData.length === filteredProjects.length) {
            for (let i = 0; i < projectData.length; i++) {
              newData[i].imageInfo = projectData[i];
            }
          }
          setData(newData);
          setIsLoading(false);
        } else {
          setData(data);
          setIsLoading(false);
        }
      })
      .catch((error) => console.log(error));
  }, [githubUrl]);

  const newTheme = `${theme} d-flex flex-column min-vh-100 justify-content-center align-items-center text-center`;

  if (isLoading) {
    return <ProjectsLoading theme={theme} />;
  }

  if (isError) {
    return <ProjectsError theme={theme} error={error} />;
  }

  // There MUST be one image per repo (see projectData.js)
  // if (data.length === projectData.length) {
  //   return (
  //     <section id="projects" className={newTheme}>
  //       <div className="container">
  //         <h2>Projects</h2>
  //         <hr />
  //         <CardColumns>
  //           {data.map((projects) => {
  //             return (
  //               <Card key={projects.id}>
  //                 <Card.Img
  //                   variant="top"
  //                   src={projects.imageInfo.image}
  //                   alt="Project Image"
  //                 />
  //                 <Card.Body>
  //                   <a
  //                     href={projects.html_url}
  //                     target="_blank"
  //                     rel="noreferrer"
  //                   >
  //                     <Card.Title className="d-inline-block">
  //                       {projects.name}
  //                     </Card.Title>
  //                   </a>
  //                 </Card.Body>
  //               </Card>
  //             );
  //           })}
  //         </CardColumns>
  //       </div>
  //     </section>
  //   );
  // }

  return (
    <section id="projects" className={newTheme}>
      <div className="container">
        <h2>Projects</h2>
        <hr />
        <CardColumns>
          {projectData.map((projects) => {
            return (
              <Card key={projects.id}>
                <Card.Img variant="top" src={projects.image} />
                <Card.Body>
                  <Card.Title style={{textDecoration:'none',fontWeight:'bold'}}>{projects.title}</Card.Title>
                  <Card.Text className="text-justify">
                    {projects.description}
                  </Card.Text>
                  {!projects.serverCode && projects.clientCode && <a href={projects.clientCode} target="_blank">
                  <Button className="btn-block"  variant="primary">Client Side Code</Button>
                  </a>}

                  {projects.serverCode && <div className="d-flex justify-content-between">
                  <a href={projects.clientCode} target="_blank">
                  <Button className="btn-block"  variant="primary">Client Side Code</Button>
                  </a>
                   <a href={projects.serverCode} target="_blank">
                  <Button className="btn-block" variant="primary">Server Side Code</Button>
                  </a>
                  </div>}
                  
                  {projects.liveSite && <a href={projects.liveSite} target="_blank">
                  <Button className="btn-block my-1" variant="primary">{projects.text}</Button>
                  </a>}
                </Card.Body>
              </Card>
            );
          })}
        </CardColumns>
      </div>
    </section>
  );
};

export default Projects;
